import { Outlet } from "react-router-dom";
import WebSidebar from "../components/views/website-dashboard/web_sidebar";

const WebsiteLayout = () => {
  return (
    <div className="d-flex overflow-x-hidden">
      <WebSidebar />
      <div className="flex-grow-1" style={{ paddingLeft: "250px" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default WebsiteLayout;
